import { NgModule } from "@angular/core";
// State
import { NgxsModule} from '@ngxs/store';
import { ChatbotState} from './chatbot.state';
// Module
import { ReactiveFormsModule } from "@angular/forms";
import { DropdownModule } from "primeng/dropdown";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng/button";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { ChatBotService } from "./service/chat-bot.service";
import { InputTextareaModule } from "primeng/inputtextarea";
import { CvComponentLibraryModule } from '@cv-invision/cv.component-library.ux';
// Components
import { ChatBotComponent } from "./chatbot.component";

@NgModule({
	imports: [
		CommonModule,
		ReactiveFormsModule,
		DropdownModule,
		ButtonModule,
		OverlayPanelModule,
		InputTextareaModule,
		CvComponentLibraryModule,
		NgxsModule.forFeature([
			ChatbotState
		])
	],
	declarations: [
		ChatBotComponent
	],
	exports: [
		ChatBotComponent

	],
	providers: [
		ChatBotService
	]
})

export class ChatBotModule { }
